import { Component } from '@angular/core';

@Component({
  selector: 'wl-app-store-logo',
  standalone: true,
  templateUrl: './app-store-logo.component.html',
})
export class AppStoreLogoComponent {}
